export const HELPS_POPUP_REFRESH_INTERVAL_MS = 2 * 60 * 1000

export const HELPS_EMERGENCY_TIME_MINUTES = 30
export const HELPS_EMERGENCY_TIME_TEST_MINUTES = HELPS_EMERGENCY_TIME_MINUTES / 3

export const HELPS_CHOOSE_PROFESSIONAL_REFRESH_INTERVAL = 1 * 60 * 10000
